import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormErrorsService {

  constructor() { }

  getErrors(form: FormGroup | FormArray): AllValidationErrors[] {
    const errors: AllValidationErrors[] = [];
    this.recurviveErrors(form, errors, ['form']);
    return errors;
  }

  private recurviveErrors(form: FormGroup | FormArray, errors: AllValidationErrors[], fields: string[]) {
    this.addErrors(form, errors, fields);

    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);

      if (control instanceof FormGroup || control instanceof FormArray) {
        this.recurviveErrors(control, errors, fields.concat(field));
        return;
      }

      this.addErrors(control, errors, fields.concat(field));
    });
  }

  private addErrors(control: AbstractControl, errors: AllValidationErrors[], fields: string[]) {
    const controlErrors: ValidationErrors = control.errors;
    if (controlErrors !== null) {
      Object.keys(controlErrors).forEach(keyError => {
        errors.push({
          controlName: fields.join('.'),
          errorName: keyError,
          errorValue: controlErrors[keyError]
        });
      });
    }
  }
}

export interface AllValidationErrors {
  controlName: string;
  errorName: string;
  errorValue: any;
}

